module.exports = __webpack_public_path__ + "img/target-savings.a47fcb36.svg";